module.exports = __webpack_public_path__ + "img/1868-14th Amendment.7fe3216d.jpg";